"use client";
import { useState } from "react";

import Portal from "@stadium/ui/src/components/portal";
import Modal from "@stadium/ui/src/components/ModalNew";
import {
  CloseButton,
  ModalBody,
  ModalContent,
  ModalDialog,
  ModalHeader,
  ModalFooter,
} from "@stadium/ui/src/components/ModalNew/utils";
import Button from "@stadium/shared/src/components/shared/button";

import { useConfig } from "@stadium/hooks/lib/use-config";

import { getBookACallCtaText } from "@stadium/shared/src/selectors/book-a-call";

import style from "./main.module.scss";

const FeatureDetailModal = ({
  header = "",
  content = "",
  handleModalBookACallClick,
  children,
}) => {
  const bookACallCtaText = useConfig(getBookACallCtaText);
  const [toggleModal, setToggleModal] = useState(false);
  const closeModal = () => {
    setToggleModal(false);
  };
  const openModal = () => {
    setToggleModal(true);
  };
  const handleBookACallClick = () => {
    closeModal();
    setTimeout(() => {
      handleModalBookACallClick?.();
    }, 0);
  };
  return (
    <>
      <Button onClick={openModal} styleType="link">
        {children}
      </Button>
      {toggleModal && (
        <Portal id="modal-root">
          <Modal
            mobileBottomDrawer
            closeOnEscape
            closeModal={closeModal}
            className={style.miniModalPricing}
            addTopMargin={false}
          >
            <ModalDialog className={style.miniModalDialog}>
              <ModalContent className={style.miniModalContent}>
                <ModalHeader className={style.miniModalHeader}>
                  <div className={style.miniModalHeaderTitle}>{header}</div>
                  <CloseButton onClick={closeModal} className={style.miniModalCloseBtn} />
                </ModalHeader>

                <ModalBody className={style.miniModalBody}>{content}</ModalBody>

                <ModalFooter className={style.miniModalFooter}>
                  <Button
                    styleType="primary"
                    onClick={handleBookACallClick}
                    className={style.miniModalFooterCta}
                    title={bookACallCtaText}
                  >
                    {bookACallCtaText}
                  </Button>
                </ModalFooter>
              </ModalContent>
            </ModalDialog>
          </Modal>
        </Portal>
      )}
    </>
  );
};

export default FeatureDetailModal;
